<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb-main user-member justify-content-sm-between">
            <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
              <h4 class="text-capitalize fw-500 breadcrumb-title">Akun Expired</h4>
            </div>
            <div class="action-btn">
              <button @click="loadList(1)" class="btn btn-secondary text-white" style="margin: 5px">
                <i class="fas fa-sync"></i> Refresh
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-info mb-3">
        <small>
          Filter menurut <b>tanggal masa aktif berakhir</b> (WIB). Email: <b>Penawaran perpanjangan</b>, <b>Diskon 30%</b>, dan
          <b>Reaktivasi 60%</b> (kupon di Admin → Kupon, checkout dengan kupon + email). CC ke starfield.id@gmail.com saat kirim ke user.
        </small>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <div v-if="activeCoupon30.code" class="alert alert-secondary py-2 mb-0">
            <small>Kupon <b>30%</b>: <b>{{ activeCoupon30.code }}</b> <span v-if="activeCoupon30.name">({{ activeCoupon30.name }})</span></small>
          </div>
          <div v-else-if="couponLoaded" class="alert alert-warning py-2 mb-0">
            <small>Belum ada kupon <b>30%</b> aktif — <router-link to="/admin/coupon">Admin → Kupon</router-link>.</small>
          </div>
        </div>
        <div class="col-md-6">
          <div v-if="activeCoupon60.code" class="alert py-2 mb-0" style="background:#fff3e0;border:1px solid #ffcc80">
            <small>Kupon <b>reaktivasi 60%</b>: <b>{{ activeCoupon60.code }}</b> <span v-if="activeCoupon60.name">({{ activeCoupon60.name }})</span></small>
          </div>
          <div v-else-if="couponLoaded" class="alert alert-warning py-2 mb-0">
            <small>Belum ada kupon <b>60%</b> (nama/kode reaktivasi, quota OK) — buat di <router-link to="/admin/coupon">Kupon</router-link>.</small>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12">
          <div class="card p-3">
            <div class="row align-items-end">
              <div class="col-md-2 mb-2">
                <label class="small mb-1">Expired dari</label>
                <input v-model="filter.date_from" type="date" class="form-control form-control-sm" @change="loadList(1)" />
              </div>
              <div class="col-md-2 mb-2">
                <label class="small mb-1">Expired sampai</label>
                <input v-model="filter.date_to" type="date" class="form-control form-control-sm" @change="loadList(1)" />
              </div>
              <div class="col-md-3 mb-2">
                <label class="small mb-1">Cari email / HP / nama</label>
                <input v-model="filter.q" type="text" class="form-control form-control-sm" placeholder="email atau no hp" @input="onSearch" />
              </div>
              <div class="col-md-2 mb-2">
                <label class="small mb-1 d-block">Filter email</label>
                <label class="small d-block mb-1">
                  <input v-model="filter.pending_offer" type="checkbox" @change="loadList(1)" />
                  Belum penawaran
                </label>
                <label class="small d-block mb-1">
                  <input v-model="filter.pending_discount" type="checkbox" @change="loadList(1)" />
                  Belum diskon 30%
                </label>
                <label class="small d-block mb-0">
                  <input v-model="filter.pending_reactivation" type="checkbox" @change="loadList(1)" />
                  Belum reaktivasi 60%
                </label>
              </div>
              <div class="col-md-2 mb-2">
                <label class="small mb-1">Durasi paket</label>
                <select v-model="filter.package_duration" class="form-control form-control-sm" @change="loadList(1)">
                  <option value="">Semua paket</option>
                  <option value="6month_1year">6 bulan &amp; 1 tahun</option>
                  <option value="6month">Hanya 6 bulan</option>
                  <option value="1year">Hanya 1 tahun</option>
                </select>
              </div>
              <div class="col-md-2 mb-2">
                <label class="small mb-1">Per halaman</label>
                <select v-model.number="filter.limit" @change="loadList(1)" class="form-control form-control-sm">
                  <option :value="25">25</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>
              <div class="col-md-1 mb-2">
                <button type="button" class="btn btn-sm btn-primary btn-block" @click="loadList(1)">
                  <i class="fas fa-filter"></i> Filter
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="selectableCount" class="row mb-2">
        <div class="col-12">
          <div class="card p-2 d-flex flex-wrap align-items-center" style="gap: 10px">
            <span class="small text-muted">{{ selectedCount }} dipilih (halaman ini)</span>
            <button
              type="button"
              class="btn btn-sm btn-primary"
              :disabled="selectedCount === 0 || bulkSending"
              @click="confirmBulkSend('renewal')"
            >
              <i class="fas fa-paper-plane"></i>
              {{ bulkSending === 'renewal' ? "Mengirim…" : "Kirim penawaran terpilih" }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-purple text-white"
              style="background:#6a1b9a;border-color:#6a1b9a"
              :disabled="selectedCount === 0 || bulkSending || !activeCoupon30.code"
              @click="confirmBulkSend('discount30')"
            >
              <i class="fas fa-percent"></i>
              {{ bulkSending === 'discount30' ? "Mengirim…" : "Diskon 30% terpilih" }}
            </button>
            <button
              type="button"
              class="btn btn-sm text-white"
              style="background:#ef6c00;border-color:#ef6c00"
              :disabled="selectedCount === 0 || bulkSending || !activeCoupon60.code"
              @click="confirmBulkSend('reactivation60')"
            >
              <i class="fas fa-bolt"></i>
              {{ bulkSending === 'reactivation60' ? "Mengirim…" : "Reaktivasi 60% terpilih" }}
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="selectedCount === 0" @click="clearSelection">
              Batal pilih
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card p-3">
            <div v-if="isLoading" class="text-center p-4"><div class="spinner-border spinner-border-sm"></div></div>
            <div v-else-if="!rows.length" class="text-muted small p-2">Tidak ada akun expired di rentang tanggal ini.</div>
            <div v-else class="table-responsive">
              <table class="table table-sm table-hover mb-0">
                <thead class="bg-light">
                  <tr>
                    <th style="width:36px">
                      <input
                        type="checkbox"
                        :checked="allSelectableSelected"
                        :disabled="selectableCount === 0"
                        @change="toggleSelectAll"
                        title="Pilih yang masih bisa dikirimi (penawaran atau diskon)"
                      />
                    </th>
                    <th>User</th>
                    <th>Paket</th>
                    <th>Tanggal berakhir</th>
                    <th>Status</th>
                    <th>Penawaran</th>
                    <th>Diskon 30%</th>
                    <th>Reaktivasi 60%</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="r in rows" :key="'exp-' + r.user_id">
                    <td>
                      <input
                        v-if="canSelectAny(r)"
                        type="checkbox"
                        :checked="isSelected(r.user_id)"
                        @change="toggleRow(r)"
                      />
                    </td>
                    <td>
                      <small>
                        <span v-if="r.email" class="d-inline-flex align-items-center flex-wrap" style="gap:4px;">
                          <button
                            type="button"
                            class="btn btn-link btn-sm p-0 text-left align-baseline expired-email-copy"
                            :title="'Salin ' + r.email"
                            @click="copyEmail(r.email)"
                          >
                            {{ r.email }}
                            <i class="far fa-copy ml-1" style="font-size:11px;opacity:0.65;"></i>
                          </button>
                        </span>
                        <span v-else>-</span>
                        <br><span class="text-muted">{{ r.phone || "" }}</span>
                      </small>
                    </td>
                    <td>
                      <small>{{ r.package_name || ("#" + r.package_id) }}</small>
                      <br><span v-if="r.package_duration" class="text-muted" style="font-size:11px">{{ formatPackageDuration(r.package_duration) }}</span>
                    </td>
                    <td><small>{{ formatTime(r.expired_at) }}</small></td>
                    <td>
                      <span v-if="r.is_expired" class="badge badge-danger">Sudah expired</span>
                      <span v-else class="badge badge-info">Akan berakhir</span>
                    </td>
                    <td>
                      <span v-if="r.offer_email_sent" class="badge badge-secondary">Terkirim</span>
                      <span v-else class="badge badge-warning text-dark">Belum</span>
                    </td>
                    <td>
                      <span v-if="r.discount_offer_email_sent" class="badge badge-secondary">Terkirim</span>
                      <span v-else class="badge badge-warning text-dark">Belum</span>
                    </td>
                    <td>
                      <span v-if="r.reactivation_offer_email_sent" class="badge badge-secondary">Terkirim</span>
                      <span v-else class="badge badge-warning text-dark">Belum</span>
                    </td>
                    <td class="text-nowrap">
                      <button
                        v-if="!r.offer_email_sent"
                        type="button"
                        class="btn btn-sm btn-outline-primary mr-1 mb-1"
                        :disabled="offerSending || bulkSending"
                        @click="openOfferModal(r, 'renewal')"
                      >
                        Penawaran
                      </button>
                      <button
                        v-if="!r.discount_offer_email_sent"
                        type="button"
                        class="btn btn-sm btn-outline-purple mr-1 mb-1"
                        style="border-color:#6a1b9a;color:#6a1b9a"
                        :disabled="offerSending || bulkSending || !activeCoupon30.code"
                        @click="openOfferModal(r, 'discount30')"
                      >
                        30%
                      </button>
                      <button
                        v-if="!r.reactivation_offer_email_sent"
                        type="button"
                        class="btn btn-sm btn-outline-warning mb-1"
                        style="border-color:#ef6c00;color:#e65100"
                        :disabled="offerSending || bulkSending || !activeCoupon60.code"
                        @click="openOfferModal(r, 'reactivation60')"
                      >
                        Reaktivasi 60%
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="!isLoading && rows.length" class="d-flex justify-content-between align-items-center pt-3">
              <small class="text-muted">{{ total }} akun — halaman {{ page }} / {{ totalPages }}</small>
              <div class="btn-group">
                <button class="btn btn-sm btn-outline-primary" @click="loadList(page - 1)" :disabled="page <= 1">←</button>
                <button class="btn btn-sm btn-outline-primary" @click="loadList(page + 1)" :disabled="page >= totalPages">→</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="offerModal.open" class="modal d-block" tabindex="-1" style="background:rgba(0,0,0,0.45)">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ offerModalTitle }}</h5>
              <button type="button" class="close" @click="closeOfferModal"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <p class="small text-muted mb-2">
                User: <b>{{ offerModal.userEmail }}</b>
                <span v-if="offerModal.packageName"> · Paket: <b>{{ offerModal.packageName }}</b></span>
                <span v-if="offerModal.couponCode"> · Kupon: <b>{{ offerModal.couponCode }}</b></span>
              </p>
              <p v-if="offerModal.checkoutUrl" class="small mb-2">
                Link checkout: <a :href="offerModal.checkoutUrl" target="_blank" rel="noopener">{{ offerModal.checkoutUrl }}</a>
              </p>
              <p v-if="offerModal.loading" class="text-muted">Memuat preview…</p>
              <template v-else>
                <label class="small font-weight-bold">Subject</label>
                <input v-model="offerModal.subject" class="form-control form-control-sm mb-2" readonly />
                <div class="border rounded p-2 mb-2" style="max-height:220px;overflow:auto;background:#fff" v-html="offerModal.html"></div>
              </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeOfferModal">Tutup</button>
              <button type="button" class="btn btn-outline-info" :disabled="offerModal.loading || offerSending" @click="sendOffer(true)">
                Test ke starfield.id@gmail.com
              </button>
              <button type="button" class="btn btn-primary" :disabled="offerModal.loading || offerSending" @click="sendOffer(false)">
                Kirim ke user
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

function fmtDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export default {
  data() {
    const now = new Date();
    const from = new Date(now);
    from.setDate(from.getDate() - 30);
    const to = new Date(now);
    to.setDate(to.getDate() + 90);
    return {
      rows: [],
      total: 0,
      page: 1,
      totalPages: 1,
      isLoading: false,
      searchDebounce: null,
      selected: {},
      bulkSending: false,
      couponLoaded: false,
      activeCoupon30: { code: "", name: "" },
      activeCoupon60: { code: "", name: "" },
      filter: {
        date_from: fmtDate(from),
        date_to: fmtDate(to),
        q: "",
        pending_offer: false,
        pending_discount: false,
        pending_reactivation: false,
        package_duration: "",
        limit: 25,
      },
      offerSending: false,
      offerModal: {
        open: false,
        mode: "renewal",
        loading: false,
        userId: 0,
        packageId: 0,
        userEmail: "",
        packageName: "",
        subject: "",
        html: "",
        couponCode: "",
        checkoutUrl: "",
      },
    };
  },
  computed: {
    selectableRows() {
      return this.rows.filter((r) => this.canSelectAny(r));
    },
    selectableCount() {
      return this.selectableRows.length;
    },
    selectedCount() {
      return Object.keys(this.selected).length;
    },
    allSelectableSelected() {
      const s = this.selectableRows;
      return s.length > 0 && s.every((r) => this.selected[r.user_id]);
    },
    offerModalTitle() {
      const m = this.offerModal.mode;
      if (m === "discount30") return "Email diskon 30%";
      if (m === "reactivation60") return "Email reaktivasi diskon 60%";
      return "Email penawaran perpanjangan";
    },
  },
  mounted() {
    this.loadActiveCoupons();
    this.loadList(1);
  },
  methods: {
    canSelectRenewal(r) {
      return r.user_id && !r.offer_email_sent;
    },
    canSelectDiscount30(r) {
      return r.user_id && !r.discount_offer_email_sent && this.activeCoupon30.code;
    },
    canSelectReactivation60(r) {
      return r.user_id && !r.reactivation_offer_email_sent && this.activeCoupon60.code;
    },
    canSelectAny(r) {
      return this.canSelectRenewal(r) || this.canSelectDiscount30(r) || this.canSelectReactivation60(r);
    },
    async loadActiveCoupons() {
      this.couponLoaded = false;
      this.activeCoupon30 = { code: "", name: "" };
      this.activeCoupon60 = { code: "", name: "" };
      try {
        const [r30, r60] = await Promise.all([
          axios.get("admin/revenue/active-discount-coupon", { params: { percent: 30 } }).catch(() => null),
          axios.get("admin/revenue/active-discount-coupon", { params: { percent: 60 } }).catch(() => null),
        ]);
        if (r30 && r30.data && r30.data.data) {
          const d = r30.data.data;
          this.activeCoupon30 = { code: d.code || "", name: d.name || d.coupon?.name || "" };
        }
        if (r60 && r60.data && r60.data.data) {
          const d = r60.data.data;
          this.activeCoupon60 = { code: d.code || "", name: d.name || d.coupon?.name || "" };
        }
      } finally {
        this.couponLoaded = true;
      }
    },
    isSelected(userId) {
      return !!this.selected[userId];
    },
    toggleRow(r) {
      if (!this.canSelectAny(r)) return;
      if (this.selected[r.user_id]) {
        const next = { ...this.selected };
        delete next[r.user_id];
        this.selected = next;
      } else {
        this.selected = { ...this.selected, [r.user_id]: { user_id: r.user_id, package_id: r.package_id } };
      }
    },
    toggleSelectAll(ev) {
      if (!ev.target.checked) {
        this.clearSelection();
        return;
      }
      const next = { ...this.selected };
      this.selectableRows.forEach((r) => {
        next[r.user_id] = { user_id: r.user_id, package_id: r.package_id };
      });
      this.selected = next;
    },
    clearSelection() {
      this.selected = {};
    },
    formatPackageDuration(days) {
      const d = Number(days) || 0;
      if (d > 35 && d <= 183) return "±6 bulan";
      if (d >= 365 && d < 1000) return "±1 tahun";
      if (d >= 25 && d <= 35) return "±1 bulan";
      if (d >= 1000) return "Lifetime";
      return d ? d + " hari" : "";
    },
    formatTime(millis) {
      if (!millis) return "-";
      return new Date(parseInt(millis)).toLocaleString("id-ID", {
        timeZone: "Asia/Jakarta",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    onSearch() {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => this.loadList(1), 500);
    },
    async loadList(p) {
      if (p < 1) return;
      this.isLoading = true;
      this.page = p;
      this.clearSelection();
      try {
        const params = {
          page: p,
          limit: this.filter.limit,
          date_from: this.filter.date_from,
          date_to: this.filter.date_to,
        };
        if (this.filter.q) params.q = this.filter.q;
        if (this.filter.pending_offer) params.pending_offer = "1";
        if (this.filter.pending_discount) params.pending_discount = "1";
        if (this.filter.pending_reactivation) params.pending_reactivation = "1";
        if (this.filter.package_duration) params.package_duration = this.filter.package_duration;
        const r = await axios.get("admin/expired-accounts", { params });
        const d = r.data.data || {};
        this.rows = d.accounts || [];
        this.total = d.total || 0;
        this.totalPages = d.total_pages || 1;
      } catch (err) {
        this.$toast.error(err.response?.data?.message || err.message);
        this.rows = [];
      } finally {
        this.isLoading = false;
      }
    },
    confirmBulkSend(mode) {
      const n = this.selectedCount;
      if (!n) return;
      const labels = {
        renewal: "penawaran perpanjangan",
        discount30: "diskon 30%",
        reactivation60: "reaktivasi diskon 60%",
      };
      const label = labels[mode] || mode;
      if (!window.confirm(`Kirim email ${label} ke ${n} akun terpilih? (CC ke starfield.id@gmail.com)`)) return;
      this.sendBulk(mode);
    },
    async sendBulk(mode) {
      const items = Object.values(this.selected);
      if (!items.length) return;
      this.bulkSending = mode;
      let url = "admin/revenue/send-package-offer-bulk";
      let body = { items };
      if (mode === "discount30") {
        url = "admin/revenue/send-package-discount-offer-bulk";
        body = { items, percent: 30 };
      } else if (mode === "reactivation60") {
        url = "admin/revenue/send-package-discount-offer-bulk";
        body = { items, percent: 60 };
      }
      try {
        const r = await axios.post(url, body);
        const d = r.data.data || {};
        this.$toast.success(r.data.message || `Terkirim: ${d.sent || 0}`);
        if (d.failed > 0 && d.results) {
          const fails = d.results.filter((x) => !x.success).slice(0, 3);
          const hint = fails.map((f) => (f.email || f.user_id) + ": " + f.message).join("; ");
          this.$toast.warning(`${d.failed} gagal — ${hint}`);
        }
        await this.loadList(this.page);
      } catch (err) {
        this.$toast.error(err.response?.data?.message || err.message);
      } finally {
        this.bulkSending = false;
      }
    },
    async copyEmail(email) {
      const text = String(email || "").trim();
      if (!text) return;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.setAttribute("readonly", "");
          ta.style.position = "fixed";
          ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        this.$toast.success("Email disalin");
      } catch (e) {
        this.$toast.error("Gagal menyalin email");
      }
    },
    closeOfferModal() {
      this.offerModal.open = false;
    },
    async openOfferModal(r, mode) {
      this.offerModal = {
        open: true,
        mode: mode || "renewal",
        loading: true,
        userId: r.user_id,
        packageId: r.package_id,
        userEmail: r.email,
        packageName: r.package_name,
        subject: "",
        html: "",
        couponCode: "",
        checkoutUrl: "",
      };
      const previewUrl =
        mode === "renewal" ? "admin/revenue/package-offer-preview" : "admin/revenue/package-discount-offer-preview";
      const previewParams = { user_id: r.user_id, package_id: r.package_id };
      if (mode === "discount30") previewParams.percent = 30;
      if (mode === "reactivation60") previewParams.percent = 60;
      try {
        const res = await axios.get(previewUrl, { params: previewParams });
        const d = res.data.data || {};
        this.offerModal.subject = d.subject || "";
        this.offerModal.html = d.html || "";
        if (d.offer_package_name) this.offerModal.packageName = d.offer_package_name;
        this.offerModal.couponCode = d.coupon_code || "";
        this.offerModal.checkoutUrl = d.checkout_url || "";
      } catch (err) {
        this.$toast.error(err.response?.data?.message || err.message);
        this.closeOfferModal();
      } finally {
        this.offerModal.loading = false;
      }
    },
    async sendOffer(isTest) {
      if (!this.offerModal.userId) return;
      this.offerSending = true;
      try {
        const body = {
          user_id: this.offerModal.userId,
          package_id: this.offerModal.packageId || 0,
        };
        if (isTest) body.send_to = "starfield.id@gmail.com";
        let url = "admin/revenue/send-package-offer";
        if (this.offerModal.mode === "discount30") {
          url = "admin/revenue/send-package-discount-offer";
          body.percent = 30;
        } else if (this.offerModal.mode === "reactivation60") {
          url = "admin/revenue/send-package-discount-offer";
          body.percent = 60;
        }
        const r = await axios.post(url, body);
        this.$toast.success(r.data.message || "Email terkirim");
        if (!isTest) {
          this.closeOfferModal();
          await this.loadList(this.page);
        }
      } catch (err) {
        this.$toast.error(err.response?.data?.message || err.message);
      } finally {
        this.offerSending = false;
      }
    },
  },
};
</script>

<style scoped>
.expired-email-copy {
  font-weight: 600;
  text-decoration: none;
  max-width: 220px;
  white-space: normal;
  word-break: break-all;
  line-height: 1.35;
}
.expired-email-copy:hover {
  text-decoration: underline;
}
</style>
